import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {of as observableOf,  Observable } from 'rxjs';
import { AnalyticsMenuItem } from '../models/analytics-menu-item';
import { AnalyticsParameter } from '../models/analytics-parameter';
import { AnalyticsInfo } from '../models/analytics-info';
import { IQueryResult } from '../../../base/interfaces/IQueryResult';
import { IAnalyticsResult } from '../interfaces/IAnalyticsResult';
import { AnalyticsColumn } from '../models/analytics-column';
import { AttributeTypes } from '../../shared/enums/attribute-types';
import { DatePipe, DecimalPipe } from '@angular/common';
import { EnviromentService } from '../../../services/enviroment.service';
import { Language } from '../../../models/language';
import { ExportType } from '../../../models/export-type.model';
import { AnalyticsExport } from '../components/analytics-filter/analytics-export';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private rootUrl: string,
    private enviromentService: EnviromentService,
  ) { 

  }
  getElement(id?:string): Observable<AnalyticsMenuItem>{
    const url = `${this.rootUrl}/analytics/elements/${id}`;
    return this.http.get<AnalyticsMenuItem>(url);
  }
  getParameters(id?:string): Observable<AnalyticsParameter[]>{
    const url = `${this.rootUrl}/analytics/${id}/parameters`;
    return this.http.get<AnalyticsParameter[]>(url);
  }
  getInfo(id?:string): Observable<AnalyticsInfo>{
    const url = `${this.rootUrl}/analytics/${id}/info`;
    return this.http.get<AnalyticsInfo>(url);
  }  
  getData(id?:string, page:number = 1, pageSize:number=100, filters?:object, sort:string = null, sortDesc:boolean = false): Observable<IAnalyticsResult<any>>{
    let qparams = new HttpParams();    
    let skip = (page - 1) * pageSize;
    let take = pageSize;
    if (skip) {
      qparams = qparams.append('$skip', skip.toString());
    }
    if (take) {
      qparams = qparams.append('$top', take.toString());
    }    
    if(filters){
      Object.keys(filters).forEach((key) => {
        let filter = filters[key];
        if(filter){
          qparams = qparams.append(key, filter);
        }
      });
    }
    if(sort){
      qparams = qparams.append('$orderby', `${sort} ${sortDesc?'desc':'asc'}`);
    }

    const url = `${this.rootUrl}/analytics/${id}/data`;
    return this.http.get<IAnalyticsResult<any>>(url, {params: qparams});
  }
  export(id?:string, code?:string, skip?:number, pageSize?:number, filters?:object, options?:AnalyticsExport, sort:string = null, sortDesc:boolean = false): Observable<any>{
    let qparams = new HttpParams();    
    let take = pageSize;
    if (skip) {
      qparams = qparams.append('$skip', skip.toString());
    }
    if (take) {
      qparams = qparams.append('$top', take.toString());
    }    
    if(filters){
      Object.keys(filters).forEach((key) => {
        let filter = filters[key];
        if(filter){
          qparams = qparams.append(key, filter);
        }
      });
    }
    if(sort){
      qparams = qparams.append('$orderby', `${sort} ${sortDesc?'desc':'asc'}`);
    }

    const url = `${this.rootUrl}/analytics/export/${id}/${code}`;
    return this.http.post<any>(url, options, {params: qparams});
  }  
  transformValue(col:AnalyticsColumn, val):any{
    let language: Language = this.enviromentService.getLanguage();
    switch(col.type)
    {
      case AttributeTypes.Number:
        return new DecimalPipe(language.code).transform(val);      
      case AttributeTypes.Date:
        return new DatePipe(language.code).transform(val, 'yyyy-MM-dd');
        case AttributeTypes.DateTime:
          return new DatePipe(language.code).transform(val, 'yyyy-MM-dd hh:MM');        
      default:
        return val;
    }    
  }
  getExportTypes(type:string) : Observable<ExportType[]> {
    return this.http.get<ExportType[]>(`${this.rootUrl}/analytics/export/${type}`);
  }  
}
